export default class URLUtils {
  static isValidJson = (jsonString: any) => {
    try {
      JSON.parse(jsonString);
      return true;
    } catch (error) {
      return false;
    }
  };

  static getBaseURL = () => {
    //let baseURL = `https://${window.location.hostname}`;
    let baseURL = process.env.REACT_APP_BACKEND;

    /*let outputsJSON: any = null;
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (
        URLUtils.isValidJson(xhttp.responseText) &&
        this.readyState === 4 &&
        this.status === 200
      ) {
        outputsJSON = JSON.parse(xhttp.responseText);
      }
    };
    xhttp.open("GET", "/outputs.json", false);
    xhttp.send();
    let backendALB = outputsJSON?.DevBackend?.BackendALB;
    if (!backendALB){
      backendALB = outputsJSON?.ProdBackend?.BackendALB;
    }
    if (backendALB) {
      //baseURL = `http://${backendALB}`;
      baseURL = `https://api.paisleyink.com`;
    }*/
    return baseURL;
  };
}
